// extracted by mini-css-extract-plugin
export var MainLogo = "index-module--MainLogo--b8b7c";
export var PcPage = "index-module--PcPage--3a00a";
export var PcPageContent = "index-module--PcPageContent--20e68";
export var QrCode = "index-module--QrCode--35f59";